import { render, staticRenderFns } from "./white-label-graphic.vue?vue&type=template&id=ad12023c&scoped=true&"
var script = {}
import style0 from "./white-label-graphic.vue?vue&type=style&index=0&id=ad12023c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad12023c",
  null
  
)

export default component.exports